<template>
	<a v-if="route.name.startsWith('index')" class="scroll-down show smooth-scroll" @click="scrollDown">
		<font-awesome-icon class="icon" icon="fa-light fa-arrow-down" size="1x" />
	</a>
</template>

<script setup>
import { defineProps, watchEffect, ref } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const scrollHeight = ref(0);

const props = defineProps({
	headerHeight: {
		type: Number,
		default: 0,
	},
});

watchEffect(() => {
	if (props.headerHeight > 0) {
		scrollHeight.value = props.headerHeight;
	}
});

const scrollDown = () => {
	window.scrollTo({
		top: window.scrollY + scrollHeight.value - 100,
		left: 0,
		behavior: 'smooth',
	});
};
</script>

<style lang="scss" scoped>
.scroll-down {
	opacity: 1;
	background: rgb(225 225 225 / 30%);
	color: #fff;
	width: 60px;
	height: 60px;
	max-width: 850px;
	text-align: center;
	line-height: 46px;
	cursor: pointer;
	box-shadow: 0 0 15px rgb(0 0 0 / 15%);
	border: 2px solid #fff;
	margin: 0 auto;
	position: absolute;
	display: flex;
	flex-flow: column;
	align-items: center;
	justify-content: center;
	bottom: 70px;
	left: 0;
	right: 0;
	padding: 0;
	z-index: 10;

	.icon {
		font-size: 20px;
	}

	&:hover {
		color: var(--cta-color);
	}
}

@media (max-width: 1480px) {
	.scroll-down {
		width: 50px;
		height: 50px;
	}
}

@media (max-width: 600px) {
	.scroll-down {
		bottom: 120px;
	}
}
</style>
